import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReceiptDialogComponent } from './receipt-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { MatTableModule } from '@angular/material/table';
import { ImageModule } from 'src/app/components/image/image.module';
import { MatRippleModule } from '@angular/material/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ReactiveFormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    ReceiptDialogComponent
  ],
  imports: [
    CommonModule,
    MatDialogModule,
    ReactiveFormsModule,
    TranslateModule,
    ImageModule,
    MatCheckboxModule,
    MatRippleModule,
    MatTableModule,
    MatButtonModule
  ]
})
export class ReceiptDialogModule { }
